export default {
    nav: {
        home: 'Ana Sayfa',
        about: 'Hakkimda',
        certifications: 'Sertifikalar',
        portfolio: 'Portfolyo',
        services: 'Hizmetler',
        contact: 'Iletisim',
        language: {
            en: 'English',
            ar: 'Arapca',
            tr: 'Turkce',
        },
    },
    hero: {
        kicker: 'Code Dragon Portfolyo',
        title: 'Benim adim Muhammed. Web gelistiricisiyim ve burada size yalnizca bir site degil, benzersiz bir deneyim sunuyorum.',
        subtitle:
            'Fikirleri temiz tasarim, yuksek performans ve rahat kullanici yolculuklariyla bulusan duyarlı ve etkilesimli arayuzlere donusturuyorum.',
        cta: 'Calismalarimi Gor',
        secondaryCta: 'Iletisime Gec',
        badges: {
            javascript: 'JavaScript',
            responsive: 'Duyarli UI',
            performance: 'Performans',
        },
    },
    about: {
        title: 'Hakkimda',
        paragraph1:
            'Ben Muhammed Garib Al-Ahmad, Anadolu Universitesinde Bilgisayar Programciligi ogrencisi ve sertifikali bir Web Gelistiricisiyim. HTML, CSS, JavaScript ve Bootstrap kullanarak modern ve yuksek performansli web arayuzleri gelistiriyorum.',
        paragraph2:
            'Vite gibi araclar ve guncel tasarim trendleriyle Code Dragon kapsaminda hizli ve kullanimi kolay web siteleri gelistiriyorum. Amacim fikirleri, temiz kod ile etkileyici tasarimin bulustugu sorunsuz dijital deneyimlere donusturmek.',
        code: `const frontendDev = {
  name: "Muhammed Garib Al-Ahmad",
  role: "Front-End Developer",
  skills: ["HTML/CSS", "JavaScript", "React"],
  focus: ["Performance", "Accessibility", "UX"]
}`,
    },
    skills: {
        html: 'HTML5 ve CSS3',
        js: 'JavaScript / ES6+',
        react: 'React',
        sass: 'SASS/SCSS',
        bootstrap: 'Bootstrap',
        tailwind: 'Tailwind CSS',
        vite: 'Vite ve Webpack',
        git: 'Git ve GitHub',
        responsive: 'Duyarli Tasarim',
    },
    certifications: {
        title: 'Sertifikalar ve Basarilar',
        subtitle: 'Web gelistirme alaninda profesyonel sertifikalar ve surekli ogrenme',
        responsive: {
            title: 'Duyarli Web Tasarimi',
            issuer: 'Udemy',
            date: '2023',
            description:
                'HTML5, CSS3 ve mobil oncelikli tasarim prensipleriyle duyarlı web siteleri gelistirme sertifikasi.',
            skills: {
                html: 'HTML5',
                css: 'CSS3',
                mobile: 'Mobil Oncelikli',
            },
        },
        ai: {
            title: 'Herkes Icin Yapay Zeka',
            issuer: 'Google / Coursera',
            date: '2026',
            description:
                'Uretkenligi artirmak ve gelistirme is akisini kolaylastirmak icin yapay zeka arac ve tekniklerini kullanma.',
            skills: {
                tools: 'AI Araclari',
                prompt: 'Prompt Muhendisligi',
            },
        },
        webInterface: {
            title: 'Web Arayuz Gelistirme',
            issuer: 'Hsoub Academy',
            date: '2026',
            description:
                'Yuksek performansli, modern ve duyarlı arayuzler gelistirme uzmanligini gosteren profesyonel sertifika.',
            skills: {
                web: 'Web Gelistirme',
                responsive: 'Duyarli Tasarim',
                performance: 'Performans',
            },
        },
    },
    portfolio: {
        title: 'One Cikan Projeler',
        projectPizza: {
            title: 'Pizza Restoran Projesi',
            description:
                'Vanilla JavaScript ile gelistirilen ve Webpack ile performansi artirilmis modern ve tam duyarlı restoran web sitesi. Etkilesimli menu, alisveris sepeti ve musteri yorumlari icerir.',
            live: 'Canli Demo',
            github: 'GitHub',
        },
        projectMajalis: {
            title: 'Majalis Al-Warraqyn',
            description:
                'Tam RTL destekli, neon esintili gorseller, akici animasyonlar ve etkilesimli bildirimlerle hizli ve etkileyici bir deneyim sunan modern Arapca landing page.',
            live: 'Canli Demo',
        },
        modal: {
            fallbackDescription: 'Proje detaylari yakinda.',
            featuresTitle: 'Temel Ozellikler',
            techTitle: 'Teknolojiler',
            close: 'Kapat',
            projects: {
                ecommerce: {
                    title: 'E-Ticaret Platformu',
                    description:
                        'Gercek zamanli stok yonetimi, alisveris sepeti ve Stripe ile guvenli odeme iceren tam ozellikli e-ticaret cozumudur.',
                    features: [
                        'Gercek zamanli stok yonetimi',
                        'Kalici depolamali alisveris sepeti',
                        'Guvenli odeme islemleri',
                        'Kullanici dogrulama ve profiller',
                        'Siparis takip sistemi',
                        'Yonetici paneli',
                    ],
                },
                analytics: {
                    title: 'Analitik Paneli',
                    description:
                        'Gercek zamanli metrikler, gelismis filtreleme ve disari aktarma ozellikleri sunan etkilesimli veri gorsellestirme paneli.',
                    features: [
                        'Gercek zamanli veri gorsellestirme',
                        'Gelismis filtreleme ve arama',
                        'Ozellestirilebilir panolar',
                        'CSV/PDF disari aktarma',
                        'Coklu grafik turleri',
                        'Performans metrikleri',
                    ],
                },
                tasks: {
                    title: 'Gorev Yonetim Uygulamasi',
                    description:
                        'Gercek zamanli guncellemeler, ekip isbirligi ve surukle-birak arayuzu sunan isbirlikci gorev yonetim araci.',
                    features: [
                        'Gorev olusturma ve yonetme',
                        'Surukle-birak arayuzu',
                        'Ekip isbirligi',
                        'Gercek zamanli guncellemeler',
                        'Son tarih hatirlatmalari',
                        'Oncelik seviyeleri',
                    ],
                },
            },
        },
    },
    features: {
        title: 'Neler Sunuyorum',
        subtitle: 'Web projelerinizi hayata gecirmek icin profesyonel on yuz gelistirme hizmetleri',
        items: {
            responsive: {
                title: 'Duyarli Web Gelistirme',
                description: 'Tum cihaz ve ekran boyutlarinda sorunsuz calisan duyarlı web siteleri olusturuyorum.',
                list: [
                    'Mobil oncelikli yaklasim',
                    'Coklu tarayici uyumlulugu',
                    'Esnek yerlesimler ve gridler',
                    'Dokunmaya uygun arayuzler',
                ],
            },
            modernJs: {
                title: 'Modern JavaScript Gelistirme',
                description: 'En yeni JavaScript frameworkleriyle etkilesimli ve dinamik web uygulamalari gelistiriyorum.',
                list: [
                    'React ve Vue.js uygulamalari',
                    'ES6+ en iyi uygulamalar',
                    'Durum yonetimi cozumleri',
                    'API entegrasyonu',
                ],
            },
            ui: {
                title: 'UI Uygulama',
                description: 'Tasarımları pixel-perfect ve islevsel web arayuzlerine donusturuyorum.',
                list: [
                    'Figma/XD tasarimini koda cevirme',
                    'CSS animasyonlari ve gecisleri',
                    'Bilesen tabanli mimari',
                    'Tasarim sistemi entegrasyonu',
                ],
            },
            performance: {
                title: 'Performans Optimizasyonu',
                description: 'En iyi kullanici deneyimi icin sitenizin hizli ve akici calismasini sagliyorum.',
                list: [
                    'Kod bolme ve lazy loading',
                    'Gorsel optimizasyonu',
                    'Paket boyutu azaltma',
                    'Performans izleme',
                ],
            },
            accessibility: {
                title: 'Web Erisilebilirligi',
                description: 'Engelli kullanicilar dahil tum kullanicilar icin erisilebilir web siteleri olusturuyorum.',
                list: [
                    'WCAG uyumlulugu',
                    'Ekran okuyucu destegi',
                    'Klavye ile gezinme',
                    'Anlamsal HTML yapisi',
                ],
            },
            maintenance: {
                title: 'Kod Bakimi ve Guncellemeler',
                description: 'On yuz kod tabanini temiz, guncel ve kolay bakimli tutuyorum.',
                list: ['Hata duzeltme ve guncellemeler', 'Kod refaktor', 'Dokumantasyon', 'Git ile surum kontrolu'],
            },
        },
    },
    contact: {
        title: 'Iletisime Gecin',
        namePlaceholder: 'Adiniz',
        emailPlaceholder: 'E-posta adresiniz',
        messagePlaceholder: 'Mesajiniz',
        submit: 'Mesaj Gonder',
        sending: 'Gonderiliyor...',
    },
    footer: {
        rights: '© 2026 Code Dragon Portfolyo. Tum haklari saklidir.',
    },
    alerts: {
        successTitle: 'Mesaj Basariyla Gonderildi! ✅',
        successBody:
            'Tesekkurler, <strong style="color: #c5a059;">{{name}}</strong>!<br>Mesajiniz basariyla gonderildi!',
        successConfirm: 'Harika!',
        errorTitle: 'Hata! ❌',
        errorText: 'Uzgunuz, bir hata olustu. Lutfen tekrar deneyin.',
        errorConfirm: 'Tamam',
        warningTitle: 'Uyari! ⚠️',
        warningConfirm: 'Tamam',
        validation: {
            nameRequired: 'Lutfen adinizi girin',
            nameShort: 'Isim en az 2 karakter olmali',
            emailRequired: 'Lutfen e-posta adresinizi girin',
            emailInvalid: 'Lutfen gecerli bir e-posta adresi girin',
            messageRequired: 'Lutfen mesajinizi girin',
            messageShort: 'Mesaj en az 10 karakter olmali',
        },
    },
};
